import React from 'react';

const Footer = () => (
  <footer className="app-footer">
    Scientex Conferences Admin Portal &copy; {new Date().getFullYear()}. All rights reserved.
  </footer>
);

export default Footer;
